import {
  Component,
  OnInit,
  Input,
  Inject,
  ChangeDetectionStrategy,
  Injector
} from '@angular/core';
import {
  WindowContainerContext,
} from '../window-context';
import { WINDOW_CONTAINER_CONTEXT } from '../tokens';

@Component({
  selector: 'dx-window-content',
  templateUrl: './window-content.component.html',
  styleUrls: ['./window-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindowContentComponent {

  public context!: WindowContainerContext<any>;

  constructor(@Inject(WINDOW_CONTAINER_CONTEXT) context: any, public injector: Injector) {
    this.context = context;
  }

}
